<template>
  <div class="container-fluid light-bg">
    <div class="container">
      <div class="container-fluid pt-9">
        <div class="text-center secondary-text font-28 pt-5 uptodown">
          <i class="fa-light fa-cubes font-60 "></i>
        </div>
        <h2 class="text-center secondary-text pt-5 bold downtoup font-30">
          {{ $getText("Service-details") }}
        </h2>
      </div>
<!--      <div class="container d-none d-lg-block ">
        <div class="row text-center ">
          <div class="col-4 " v-for="(item,i) in Special " :key="i">
            <div class="flip-card-SpecialPacks">
              <div class="flip-card-inner-SpecialPacks border righttoleft">
                <div class="flip-card-front-SpecialPacks ">
                  <v-card
                      class="mx-auto "
                      max-width="400"
                  >
                    <div class="shape-top" dir="ltr">
                      <div class="text-center ">
                        <i :class="item.icons " class="font-40 pt-5 card-text"></i>
                      </div>
                      <h5 class=" mb-8 text-center pt-3 bold card-text"> {{ item.title }} </h5>
                      <p class="mb-16 font-12 px-3 text-center card-text">{{ item.text }}</p>
                    </div>
                    <div class="container">
                      <v-card-text class="">
                        <p class=" font-12 text-center">
                          {{ item.cheklist1 }}
                        </p>
                        <v-divider></v-divider>
                        <p class=" font-12 text-center">
                          {{ item.cheklist2 }}
                        </p>
                        <v-divider></v-divider>
                        <p class=" font-12 text-center">
                          {{ item.cheklist3 }}
                        </p>
                        <v-divider></v-divider>
                        <p class=" font-12 text-center">
                          {{ item.cheklist4 }}
                        </p>
                        <v-divider></v-divider>
                        <p class=" font-12 text-center">
                          {{ item.cheklist5 }}
                        </p>
                      </v-card-text>
                    </div>
                  </v-card>
                </div>
                <div class="flip-card-back-SpecialPacks pt-16">
                  <h5 class="mb-8 mt-16 text-center bold card-text w"> {{ item.title }} </h5>

                  <v-btn
                      class=" mt-16 text-center"
                      color="white"
                      outlined
                      primary
                      x-large
                  >
                    <i class="fa-solid fa-angle-right pl-5 "></i>
                    {{ item.btn }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <div class="">
        <div class="row">
          <div class="col-12 col-lg-4" v-for="(item,i) in Special" :key="i">
            <div class="">
              <v-card
                  class="mx-auto"
              >
            <div class="shape-top py-5">
                  <div class="text-center">
                    <i :class="item.icons" class="font-50 pt-6 card-text"></i>
                  </div>
                  <h6 class="text-center card-text pt-5"> {{ item.title }} </h6>
<!--                  <p class="mb-8 font-12 text-center card-text px-2">{{ item.text }}</p>-->
            </div>
                <div class="container">
                  <v-card-text class="">
                    <p class="h-special-p font-14 text-center border-bottom align-self-center my-0">
                      {{ item.cheklist1 }}
                    </p>

                    <p class="h-special-p font-14 text-center border-bottom align-self-center mb-0">
                      {{ item.cheklist2 }}
                    </p>

                    <p class="h-special-p font-14 text-center border-bottom align-self-center mb-0">
                      {{ item.cheklist3 }}
                    </p>

                    <p class="h-special-p font-14 text-center border-bottom align-self-center mb-0">
                      {{ item.cheklist4 }}
                    </p>

                    <p class="h-special-p font-14 text-center  align-self-center mb-0">
                      {{ item.cheklist5 }}
                    </p>
                  </v-card-text>
                </div>
<!--               <div class="shape-button">
                  <div class="text-center pt-16">
                    <v-btn
                        class=""
                        outlined
                        color="white"
                        x-large
                    >
                      <i class="fa-solid fa-angle-right pl-5 "></i>
                      {{ item.btn }}
                    </v-btn>
                  </div>
               </div>-->
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpecialPacks",
  data: () => ({
    Special: [
      {
        id: "1",
        icons: "fa-light fa-mobile-screen",
        title: "اپلیکیشن موبایل",
        btn: "Send Request",
        text: "These are the management services we provide the IT support and maintenance.  ",
        count: "230",
        cheklist1: "برقراری ارتباط آسانتر و بهتر میان مشتری و برند",
        cheklist2: "فروشگاهی بدون محدودیت زمانی و مکانی",
        cheklist3: "برند سازی و ایجاد تمایز کسب و کار بین رقبا",
        cheklist4: "تسهیل خرید و ترغیب مشتری برای خرید",
        cheklist5: "عملکرد ساده تر و سریع تر اپ ها نسبت به وبسایت",

      },
      {
        id: "2",
        icons: "fa-light fa-desktop",
        title: "وب سایت",
        btn: "Send Request",
        text: "It is the process of configuring virtual cloud systems that businesses need.",
        count: "420",
        cheklist1: "برقراری ارتباط مستقیم میان مشتری و برند",
        cheklist2: "فروشگاهی بدون محدودیت زمانی و مکانی",
        cheklist3: "برند سازی و ایجاد تمایز کسب و کار بین رقبا",
        cheklist4: "امکان عرضه بر مبنای تقاضا",
        cheklist5: "کاهش هزینه های جانبی و افزایش درآمد",
      },
      {
        id: "3",
        icons: "fa-light fa-laptop-mobile",
        title: "PWA",
        btn: "Send Request",
        text: " It is the process of configuring virtual servers that businesses need. ",
        count: "560",
        cheklist1: "امکان استفاده از اپلیکیشن به صورت آفلاین",
        cheklist2: "قابل اجرا روی همه دستگاه ها و سیستم عامل های مختلف",
        cheklist3: "عدم نیاز به نصب و مراحل فعالسازی",
        cheklist4: "عدم تداخل نسخه های مختلف و نیاز به آپدیت مستمر",
        cheklist5: "حجم کمتر و سرعت لود بالاتر",
      },
    ],
  }),
  mounted() {

  }
}
</script>

<style scoped>

</style>